import {useState, useEffect} from 'react';
import { httpGet, APIEndpoint, EndpointType } from '../utils/apiService'
import { AIConversation, ConversationsResponse } from '../models/Conversation';

const apiURL =  APIEndpoint(EndpointType.Conversations);

export const useConversations = (customerID: string, refreshKey: number) => {
    const [conversations, setConversations] = useState<AIConversation[]>([])
    const [conversationsError, setError] = useState("")
    const [conversationsLoading, setLoading] = useState(false)

    useEffect(() => {        
        if (refreshKey <= 0) {
            return
        }

        setLoading(true)
        setError("")
        const url = apiURL + "?customer_id=" + customerID;

        httpGet(url)
            .then((data) => {
                const conversationsResponse = data as ConversationsResponse;
                
                if (conversationsResponse.status == "error") {
                    setError(conversationsResponse.errorMessage)
                    return
                }
                if (conversationsResponse.conversations) {
                    if (conversationsResponse.conversations.length > 0) {
                        setConversations(conversationsResponse.conversations);
                    }
                } else {
                    setConversations([]);
                }
                
            })
            .catch((error) => setError(error))
            .finally(() => setLoading(false))

    }, [customerID, refreshKey]);

    return { conversations, conversationsLoading, conversationsError };
};